import React from "react";
import Layout from "components/layout/layout";
import { MDXRenderer } from "gatsby-plugin-mdx";
import {Container} from "reactstrap";
import SEO from "components/seo";

const DocumentPage = ({ pageContext, location }) => {
    return (
    <Layout locale={pageContext.item.frontmatter.language} location={location}>
        <div className="MainContent">
            <Container>
                <div className="SideBarBox">
                    <div className="TextBlock">{pageContext.item.frontmatter.title}
                        <MDXRenderer>{pageContext.item.body}</MDXRenderer>
                    </div>
                </div>
            </Container>
        </div>
        <SEO description={pageContext.item.frontmatter.description} title={pageContext.item.frontmatter.title} author={pageContext.item.frontmatter.author} />
    </Layout>
  );
};

export default DocumentPage;
